<template>
<b-container class="ticket-detail-main">
    <div :class="{'expired': expired, 'ticket-details': true}">
        <div class="ticket-detail-head" >
            <h1>{{ticket.title}}</h1>
            <div class="info">
                <div class="info-1">
                    <div> <strong>{{$t('ticket.detail.client')}}: </strong> {{ticket.customer.name}} </div>
                    
                    <div v-if="isSubscription"> <strong>{{$t('ticket.detail.subscription')}}: </strong> {{ticket.customer_sub.subscription_name}} </div>
                    <div v-if="!isSubscription"> <strong>{{$t('ticket.detail.product')}}: </strong> {{ticket.customer_product.product_name}} </div>
                    
                    <div> <strong>{{$t('ticket.detail.assignedUser')}}: </strong> {{assignedFullName}} </div>
                </div>
                <div class="info-2">
                    <div> <strong>{{$t('ticket.detail.date')}}: </strong> {{dateFormat(ticket.created_at)}} </div>
                    <div> <strong>{{$t('ticket.detail.updatedAt')}}: </strong> {{dateFormat(ticket.updated_at)}} </div>
                    <div v-if="isSubscription"> <strong>{{$t('ticket.detail.subscriptionDate')}}: </strong> {{dateFormat(ticket.customer_sub.end_date)}} </div>

                </div>
            </div>
        </div>

        <div class="ticket-detail-footer">
            <b-alert v-if="supStatus == 'open'" variant="danger" show>
                <b-icon icon="exclamation-triangle-fill" animation="throb" font-scale="1.5" ></b-icon>
                <span > {{$t('ticket.active')}}  </span>
            </b-alert>
            <b-alert v-else-if="supStatus == 'pending'" variant="warning" show>
                <b-icon icon="clock" animation="throb" font-scale="1.5" ></b-icon>
                <span > {{$t('ticket.pending')}}  </span>
            </b-alert>
            <b-alert v-else variant="success" show>
                <b-icon icon="check" animation="throb" font-scale="1.5" ></b-icon>
                <span > {{$t('ticket.passive')}}  - {{ticket.status.description}}</span>
            </b-alert>
            
            <div class="buttons">
                <b-button variant="danger" @click="openModal(true, 'changeState')"> Durum Değiştir </b-button>
                <b-button variant="warning" @click="openModal(true, 'appointment')">{{$t('ticket.detail.assign')}}</b-button>
                <b-button variant="primary" @click="openModal(true, 'add')">{{$t('ticket.comment.makeComment')}}</b-button>
            </div>
        </div>

    </div>

    <CommentCard
        v-for="comment in comments" 
        :key='comment.id'
        :comment='comment'
        :ticket_id='ticket.id'
        :openModal="openModal"
    />

    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
</b-container>

</template>

<script>
import { VueEditor } from "vue2-editor";
import CommentCard from './CommentCard.vue'
import Modals from '../modals'
import moment from 'moment'
import i18n from '@/plugins/i18n';

  export default {
    components:{
        VueEditor, CommentCard, Modals
    },
    props: {
        ticket: Object,
        comments: Array,
        expired: Boolean
    },
    data() {
        return {
            modalOpen: false,
            modalProps: {},
            modalName: "",
            currentForm: '',
        }
    },
    computed: {
        supStatus() {
            return this.ticket.support_status
        },
        isSubscription() {
            return this.ticket.customer_sub.id
        },
        assignedFullName() {
            const fullname = this.ticket.assigned_user.first_name ? 
            `${this.ticket.assigned_user.first_name} 
             ${this.ticket.assigned_user.last_name}` : 
            i18n.t('ticket.detail.notAssigned')
            return fullname
        }
    },
    methods: {
        dateFormat(val){
            return moment(String(val)).format('DD.MM.YYYY') 
        },
        openModal(state, modal, props = { ticket_id: this.ticket.id }) {
            this.modalOpen = state
            if(state){
                this.modalProps = props
                this.modalName = modal
            }
        },
    }
}
</script>
<style lang="css" scoped> 
@import "../styles/ticket-detail.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/components/TicketMessage.vue